/* eslint-disable no-param-reassign */

import { types } from "mobx-state-tree";

const WorkSession = types.model("WorkSessionModel", {
  id: types.number,
  startedAt: types.maybeNull(types.string),
  endedAt: types.maybeNull(types.string),
});

export default WorkSession;
